import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { RootState } from '../store';
import { storageFactory } from 'src/helpers/storage';
const local = storageFactory(() => localStorage);

const initialState: IQuizState = {
    quizList: [],
    popupQuizList: [],
};

export const QUIZ_TYPE_STATIC = 1;
export const QUIZ_TYPE_POPUP = 2;
export const QUIZ_STATUS_UNACTIVE = 0;
export const QUIZ_STATUS_ACTIVE = 1;
export const QUIZ_STORAGE = 'quiz_popup_activity';

export const quiz = createSlice({
    name: 'quiz',
    initialState,
    reducers: {
        setAndSortQuizList: (state, action: PayloadAction<IQuizListPayload>) => {
            const { payload } = action;
            state.quizList = payload.quizList.filter((quiz: IQuizItem) => quiz.type === QUIZ_TYPE_STATIC && quiz.status === QUIZ_STATUS_ACTIVE);
            const popupQuizList = payload.quizList.filter((quiz: IQuizItem) => quiz.type === QUIZ_TYPE_POPUP && quiz.status === QUIZ_STATUS_ACTIVE);
            const storageActiveDates = JSON.parse(local.getItem(QUIZ_STORAGE) || '[]');
            const mappedList: IQuizItemPopup[] = popupQuizList.map((quiz: IQuizItem): IQuizItemPopup => {
                const storedActivityDate: IStoredQuizActivity = storageActiveDates.find((item: {id: string}) => item.id === quiz.id);
                return {
                    ...quiz,
                    lastActiveDate: storedActivityDate?.date || '',
                };
            });
            state.popupQuizList = mappedList;
        },
        updateQuizActivityDay: (state, action: PayloadAction<IStoredQuizActivity>) => {
            const { payload } = action;
            state.popupQuizList.forEach((quiz) => {
                if (quiz.id === payload.id) {
                    quiz.lastActiveDate = payload.date;
                }
            });
        },
    },
});

export default quiz.reducer;

export const {
    setAndSortQuizList,
    updateQuizActivityDay,
} = quiz.actions;

export const getHomePageQuizList = (state: RootState) => state.quiz.quizList;
export const getPopupQuizList = (state: RootState) => state.quiz.popupQuizList;

interface IQuizState {
    quizList: IQuizItem[];
    popupQuizList: IQuizItemPopup[];
};

export interface IQuizItem {
    access: number;
    answerVariants: IQuizAnswers[];
    fillColor: string;
    hasAnswers: boolean;
    id: string;
    image: string | null;
    multiselect: boolean;
    question: string;
    questionEn: string | null;
    status: number;
    timeout: number;
    type: number;
};

export interface IQuizItemPopup extends IQuizItem {
    lastActiveDate: string;
};
export interface IQuizAnswers {
    en: string | null;
    ru: string;
    id: string;
};

export interface IQuizListPayload {
    quizList: IQuizItem[];
};


export interface IStoredQuizActivity {
    id: string;
    date: string;
}
